module.exports = __webpack_public_path__ + "img/3_kmart.192ec3fa.jpg";